// TelcoTrack - Main Application Module
// Root module that bootstraps the Angular application

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';

// NgRx Store
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// Angular Material (if needed for specific components)
// import { MatIconModule } from '@angular/material/icon';
// import { MatTooltipModule } from '@angular/material/tooltip';

// Core modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

// Feature modules
import { AuthModule } from './features/auth/auth.module';
import { ConstructionDiarySharedModule } from './features/construction-diary/construction-diary-shared.module';

// Routing
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';

// Root component
import { AppComponent } from './app.component';

// Environment
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // Angular core modules
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,

    // SW build is disabled in angular.json (serviceWorker: false) — do not register
    // a missing ngsw-worker.js (nginx used to return index.html → MIME error / blank UI).
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      registrationStrategy: 'registerWhenStable:30000'
    }),

    // NgRx Store
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production
    }),

    // Angular Material (minimal usage)
    // MatIconModule,
    // MatTooltipModule,

    // Application modules
    CoreModule,
    SharedModule,

    // Feature modules
    AuthModule,
    ConstructionDiarySharedModule,

    // Routing (must be last)
    RouterModule,
    AppRoutingModule
  ],
  providers: [
    // Global providers are configured in CoreModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
